import React from 'react';

export default function About() {
  return (
    <section className="pt-28 pb-32 px-6 min-h-screen" style={{ background: '#082318' }}>
      {/* Hero banner */}
      <div
        className="relative w-full rounded-3xl overflow-hidden mb-20 py-20 px-8 text-center"
        style={{ background: 'linear-gradient(135deg, #0c2e1e 0%, #0e3322 100%)', border: '1px solid rgba(212,245,66,0.12)' }}
      >
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[200px] pointer-events-none"
          style={{ background: 'radial-gradient(ellipse, rgba(212,245,66,0.07) 0%, transparent 70%)' }} />
        <p className="text-sm font-mono uppercase tracking-widest mb-4 font-semibold" style={{ color: '#d4f542' }}>Our Story</p>
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white tracking-tight leading-tight max-w-4xl mx-auto">
          Professional AI-powered digital products<br className="hidden md:block" /> engineered for measurable results.
        </h1>
        <p className="mt-6 max-w-2xl mx-auto text-base leading-relaxed" style={{ color: 'rgba(255,255,255,0.55)' }}>
          We help companies streamline operations, convert more leads, and build trust with enterprise-grade websites that are fast, secure, and built to scale.
        </p>
      </div>

      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Beliefs */}
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-white tracking-tight mb-8">What we believe</h2>
            <p className="text-base leading-relaxed mb-8" style={{ color: 'rgba(255,255,255,0.55)' }}>
              Design and technology should work together to create clarity, trust, and conversion. Our approach combines modern UX with automated workflows that save time and keep your business consistently in front of the right audience.
            </p>
            <ul className="space-y-5">
              {[
                { title: 'Strategy first.', body: 'Every project starts with clear business goals, measurable KPIs, and a roadmap that ties design decisions back to revenue.' },
                { title: 'Automation as standard.', body: 'We build systems that collect leads, qualify inquiries, and trigger follow-ups automatically — so nothing slips through the cracks.' },
                { title: 'Privacy and security built-in.', body: 'Our solutions are designed with the latest best practices so your site works reliably and your customer data stays safe.' },
              ].map((item, i) => (
                <li key={i} className="flex gap-3 text-sm leading-relaxed" style={{ color: 'rgba(255,255,255,0.6)' }}>
                  <span className="font-bold text-white flex-shrink-0">{item.title}</span>
                  {item.body}
                </li>
              ))}
            </ul>
          </div>

          {/* Founder card */}
          <div
            className="rounded-3xl p-10"
            style={{ background: '#0c2d1e', border: '1px solid rgba(255,255,255,0.08)' }}
          >
            <div className="flex items-start gap-5 mb-7">
              <div className="h-24 w-24 rounded-2xl overflow-hidden flex-shrink-0" style={{ background: '#0e3322' }}>
                <img src="/assets/arlind.jpg" alt="Arlind Bajraktari" className="h-full w-full object-cover" />
              </div>
              <div>
                <h3 className="text-xl font-bold text-white">Arlind Bajraktari</h3>
                <p className="text-sm mt-1" style={{ color: '#d4f542' }}>CEO & Technical Founder</p>
              </div>
            </div>

            <p className="text-sm leading-relaxed mb-6" style={{ color: 'rgba(255,255,255,0.55)' }}>
              Arlind brings over 7 years of experience delivering digital products for startups and established brands. His background includes web engineering, infrastructure automation, and strategic product design.
            </p>

            <ul className="space-y-2 text-sm mb-8" style={{ color: 'rgba(255,255,255,0.5)' }}>
              <li className="flex gap-2"><span style={{ color: '#d4f542' }}>•</span> Led development of SaaS platforms serving thousands of users</li>
              <li className="flex gap-2"><span style={{ color: '#d4f542' }}>•</span> Designed secure, scalable infrastructure for high-traffic sites</li>
              <li className="flex gap-2"><span style={{ color: '#d4f542' }}>•</span> Built AI-driven lead qualification systems and automation pipelines</li>
            </ul>

            <div className="flex flex-wrap gap-3 pt-6" style={{ borderTop: '1px solid rgba(255,255,255,0.07)' }}>
              {[
                { label: '✉ Email', href: 'mailto:hello@synex.agency' },
                { label: 'in LinkedIn', href: '#' },
                { label: 'Dr Dribbble', href: '#' },
              ].map(link => (
                <a
                  key={link.label}
                  href={link.href}
                  className="px-4 py-2 rounded-full text-xs font-semibold transition hover:opacity-80"
                  style={{ background: 'rgba(212,245,66,0.1)', color: '#d4f542', border: '1px solid rgba(212,245,66,0.2)' }}
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

